import { ShoppingCart } from "lucide-react";
import { useLanguageStore } from "@/stores/language";

export const EmptyCart = () => {
  const { t } = useLanguageStore();

  return (
    <div className="flex-1 flex items-center justify-center">
      <div className="text-center" role="status" aria-live="polite">
        <ShoppingCart 
          className="h-12 w-12 text-muted-foreground mx-auto mb-4" 
          aria-hidden="true"
        />
        <p className="text-muted-foreground">
          {t("Your cart is empty", "Tu carrito está vacío")}
        </p>
      </div>
    </div>
  );
};
